
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.754 5.915l-6.89-2.861a.703.703 0 00-.54 0l-6.89 2.86a.703.703 0 00-.434.65v3.478c0 4.789 2.894 9.096 7.328 10.906.17.07.361.07.532 0a11.775 11.775 0 007.328-10.906V6.564a.703.703 0 00-.434-.65zm-.973 4.127c0 4.07-2.39 7.818-6.187 9.491a10.371 10.371 0 01-6.188-9.491V7.033l6.188-2.569 6.187 2.57v3.008zm-6.964 2.37l3.022-3.022a.703.703 0 11.994.994l-3.52 3.52a.703.703 0 01-.994 0l-1.965-1.966a.703.703 0 11.995-.994l1.468 1.468z"}})])
          )
        }
      }
    